import { cn } from 'utils/cn';
import { localize } from 'i18n/localize';
import { Icon } from 'components/atoms/Icon';

type Props = {
	className?: string;
};

const $t = localize();

export function RejectedOverlay({ className }: Props) {
	return (
		<div className={cn('text-white text-center text-xs @cardLg:text-sm', className)}>
			<div className="bg-red py-1 @cardMd:py-2 @cardLg:py-4 rounded-t-xl">
				<strong className="inline-flex text-sm @cardLg:text-base">
					<Icon type="gpp_bad" size={24} fill className="flex-shrink-0 mr-1" />{' '}
					{$t.rejectedOfferOverlay.title}
				</strong>
				<p>{$t.rejectedOfferOverlay.subtitle}</p>
			</div>
			<div className="bg-dark-blue-80 py-1 @cardMd:py-2 @cardLg:py-3 px-1 @cardMd:px-2 @cardLg:px-5 rounded-b-xl @card2Xl:flex">
				<p>{$t.rejectedOfferOverlay.adminRejected}</p>
				<span class="hidden @card2Xl:inline">.&nbsp;</span>
				<p>{$t.rejectedOfferOverlay.sentByEmail}</p>
			</div>
		</div>
	);
}
